<template>
  <div class="listUsers">
    <div class="info-member">
      <user-photo
        :user="user"
        :is-broadcaster="isBroadcaster"
        class="liker-photo"
      />
      <div class="liker-names" @click="goToUserInfo(user)">
        {{ user.firstName }} {{ user.lastName }}
      </div>
    </div>
  </div>
</template>

<script>
import UserPhoto from '@/components/shared/UserPhoto'

export default {
  name: 'UserLink',
  components: { UserPhoto },
  props: {
    user: {
      type: Object,
      default: () => []
    },
    isBroadcaster: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    goToUserInfo (user) {
      this.$router.push({ name: 'userInfo', params: { id: user.id } })
    }
  }
}
</script>

<style scoped lang="scss">
.listUsers {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;

    .info-member {
      display: flex;

      .liker-photo {
          height: 32px;
          width: 32px;
          padding: 6px 0 6px 12px;
          border-radius: 100%;
      }

      .liker-names {
          padding: 11px 0 12px 8px;
          height: 21px;
      }

      .liker-names:hover {
          cursor: pointer;
      }

    }
}

</style>
